import { render, staticRenderFns } from "./underlyingReferenceChange.vue?vue&type=template&id=0b091432"
import script from "./underlyingReferenceChange.vue?vue&type=script&lang=js"
export * from "./underlyingReferenceChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports